// extracted by mini-css-extract-plugin
export default {"content":"yqE7yCxmzkeLjs5260Ko","text":"CjEZYO2UNS82_lwq0Ajg","register":"ahAf2RddsRDOGjcivsfx"};